import { CausedByException } from '@core/types'

export class JwtSignError extends CausedByException {
	override message = 'Failed to sign JWT token'
}

export class JwtVerifyError extends CausedByException {
	override message = 'Failed to verify JWT token'
}
